<div *ngIf="order" class="order-header fx-layout-row fx-align--x-center fx-align--space-between-x">

  <mbnm-order-progress class="order-progress hide-xs" [order]="order"></mbnm-order-progress>

  <div class="actions fx-layout-row fx-gap--16px">
    <div>
      <button mat-mini-fab="" color="tertiary" [disabled]="!order.TrackingLink && !order.TrackingNumber" (click)="trackPackage($event)">
        <mat-icon svgIcon="shipping"></mat-icon>
      </button>
      <label>track</label>
    </div>

    <div>
      <button mat-mini-fab="" color="tertiary" [disabled]="order.Status !== 'NEW' && order.Status !== 'READY'" (click)="cancelOrder($event)">
        <mat-icon svgIcon="x"></mat-icon>
      </button>
      <label>cancel</label>
    </div>

    <div>
      <button mat-mini-fab="" color="tertiary" [disabled]="order.Status === 'SHIPPED' || order.Status === 'DELIVERED' || order.Status === 'CANCELLED' || order.ConfirmationCode == orderBeingEdited" (click)="changeOrder($event)">
        <mat-icon svgIcon="pencil"></mat-icon>
      </button>
      <label>change</label>
    </div>

    <div>
      <button mat-mini-fab="" color="tertiary" (click)="showContactForm($event)">
        <mat-icon svgIcon="email"></mat-icon>
      </button>
      <label>contact</label>
    </div>

    <div>
      <button mat-mini-fab="" color="tertiary" (click)="print()">
        <mat-icon svgIcon="print"></mat-icon>
      </button>
      <label>print</label>
    </div>

    <div *ngIf="order.Status === 'SHIPPED' || order.Status === 'DELIVERED' || order.Status === 'CANCELLED'">
      <button mat-mini-fab="" color="primary" (click)="addToCart()">
        <mat-icon svgIcon="cart-plus"></mat-icon>
      </button>
      <label>re-order</label>
    </div>
  </div>
</div>

<div class="order" *ngIf="order">
  <ng-container *ngIf="media.isMatched(BREAKPOINTS.Standard.XSmall)">
    <h3>
      Order Status: <span class="text-highlight">{{ order.Status}}</span>
    </h3>
    <mbnm-order-progress *ngIf="media.isMatched(BREAKPOINTS.Standard.XSmall)" [order]="order"></mbnm-order-progress>
  </ng-container>

  <div class="order-meta fx-layout-row fx-layout-column--xs fx-align--x-start">
    <div class="fx-flex--33--gt-xs fx-flex--100--xs">
      <h3>Order #: <span class="text-highlight">{{order.ConfirmationCode}}</span></h3>
      <h4>Your Info</h4>
      <div>{{order.FullName}}</div>
      <div>{{order.Email}}</div>
      <div>{{order.PhoneNumber}}</div>
    </div>
    <div class="fx-flex--33--gt-xs fx-flex--100--xs">
      <h3>Order Date: <span class="text-highlight">{{order.RecordCreated | date:'shortDate'}}</span></h3>
      <h4>Shipping Info</h4>
      <div>{{order.Cart.shipping.fullname}}</div>
      <div>{{order.Cart.shipping.addressLine1}}</div>
      <div *ngIf="order.Cart.shipping && order.Cart.shipping.addressLine2">{{order.Cart.shipping.addressLine2}}</div>
      <div>{{order.Cart.shipping.city}}, {{order.Cart.shipping.state}} {{order.Cart.shipping.zipCode}}</div>
      <div *ngIf="order.TrackingNumber">
        <a target="_track" href="{{order.TrackingLink}}">{{order.TrackingNumber}}</a>
      </div>
    </div>
    <div class="fx-flex--33--gt-xs fx-flex--100--xs">
      <h3 *ngIf="media.isMatched(BREAKPOINTS.GreaterThanXSmall) || media.isMatched('print')">
        Status: <span class="text-highlight">{{ order.Status}}</span>
      </h3>
      <ng-container *ngIf="!order.Cart.payment">
        <h4>Billing Info</h4>
        <ng-container *ngIf="order.Cart.billing">
          <div>{{order.Cart.billing.fullname}}</div>
          <div>{{order.Cart.billing.addressLine1}}</div>
          <div *ngIf="order.Cart.billing.addressLine2">{{order.Cart.billing.addressLine2}}</div>
          <div>{{order.Cart.billing.city}}, {{order.Cart.billing.state}} {{order.Cart.billing.zipCode}}</div>
        </ng-container>
        <ng-container *ngIf="!order.Cart.billing">
          None Provided
        </ng-container>
      </ng-container>
      <ng-container *ngIf="order.Cart.payment && order.Cart.payment.hint">
        <h4>Payment Info</h4>
        <div *ngIf="order.Cart.payment.hint.paymentMethod === 'not-provided'">Not Required</div>
        <div>{{order.Cart.payment.hint.nameOnAccount}}</div>
        <div>{{order.Cart.payment.hint.primaryAccountDetailMask}}</div>
      </ng-container>
    </div>
  </div>

  <h3>Order Details</h3>

  <div class="price-disclaimer">Prices may have changed since purchase.</div>

  @for (cartItem of cartItems; track cartItem.id; let idx = $index) {
  <mbnm-cart-item [cartItem]="cartItem"
                  [readonly]="true"
                  [enableReBuy]="order.Status === 'SHIPPED' || order.Status === 'DELIVERED' || order.Status === 'CANCELLED'"
                  (reBuyRequested)="addToCart($event)"
                  [hideDivider]="idx === 0">
  </mbnm-cart-item>
  }
  
  <div class="fx-layout-row fx-align--end-x">
    <div class="order-totals fx-layout-row fx-layout-wrap">
      <div class="label fx-flex--50">Sub Total:</div>
      <div class="value fx-flex--50" [innerHtml]="order.Cart.subTotal | currency2"></div>

      <div class="label fx-flex--50">Shipping:</div>
      <div class="value fx-flex--50" [innerHtml]="order.Cart.shippingTotal ? (order.Cart.shippingTotal | currency2 ) : 'FREE'"></div>

      <ng-container *ngIf="order.Cart.oversizeHandling">
        <div class="label fx-flex--50">Oversize Fee:</div>
        <div class="value fx-flex--50" [innerHtml]="order.Cart.oversizeHandling | currency2"></div>
      </ng-container>

      <ng-container *ngIf="order.Cart.lowTotalHandling">
        <div class="label fx-flex--50">Setup Fee:</div>
        <div class="value fx-flex--50" [innerHtml]="order.Cart.lowTotalHandling | currency2"></div>
      </ng-container>

      <div class="label fx-flex--50">Taxes:</div>
      <div class="value fx-flex--50" [innerHtml]="order.Cart.tax | currency2"></div>

      <ng-container *ngIf="order.Discount">
        <div class="label fx-flex--50">Discount:</div>
        <div class="value fx-flex--50"[innerHtml]="'(' + (order.Cart.discount | currency2) + ')'"></div>
      </ng-container>

      <div class="grandTotal label fx-flex--50"><strong>Grand Total:</strong></div>
      <div class="grandTotal value fx-flex--50">
        <strong [innerHtml]="order.Cart.grandTotal | currency2"></strong>
      </div>
    </div>
  </div>
</div>

@if (!order && error) {
  @if (currentUser.isAnonymous) {
    <div class="error">
      <h3>Please login to view your order.</h3>
      <p *ngIf="currentUser.isAnonymous">
        Order details are only visible when you login for security details.
      </p>
    </div>
  } @else {
    <div class="error">
      <h3>An error has occurred loading this order.</h3>
      <p *ngIf="currentUser.isAnonymous">
        This order was not found, or does not belong to the logged in account.
      </p>
    </div>
  }
}
<mbnm-personal-info [hidden]="true"></mbnm-personal-info>
